module.exports = __webpack_public_path__ + "static/logo-word-mark-2e9d296c982ead37960f6da69d181627.svg";